import { render, staticRenderFns } from "./employeeData.vue?vue&type=template&id=4fce907f&scoped=true&"
import script from "./employeeData.vue?vue&type=script&lang=js&"
export * from "./employeeData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fce907f",
  null
  
)

export default component.exports